import React from 'react';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';

import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';

import Table from '../../components/Table/Table';
import { ButtonWarning } from '../../components/Button/Button';

import { numberFormat } from '../../helper/MaskHelper';
import { isAdministradorOuCentral } from '../../security/AuthorizedFunction';
import { capitalizeWords } from '../../variables/Enums/Enum';

const VERDE = '#2e7d32';
const VERMELHO = '#c62828';

const CATEGORIAS = {
    RECEBIMENTO: 'Recebimento',
    DIGITALIZACAO: 'Digitalização',
    CORTE: 'Corte',
    LEITURA: 'Leitura de Marcações',
    DIGITACAO: 'Digitação',
    TRATAMENTO: 'Tratamento',
    REVISAO: 'Revisão',
};

const humanizarCategoria = categoria => {
    if (!categoria)
        return '';

    return CATEGORIAS[categoria] ?? capitalizeWords(categoria.replace(/_/g, ' '));
};

export const Checks = ({ checks, loading }) => {
    if (!isAdministradorOuCentral())
        return null;

    const dados = checks ?? [];

    const pendentes = dados.filter(c => !c.ok).length;

    const buscarCheck = id => dados.find(c => c.id === id);

    const columns = [
        { label: 'Descrição', name: 'descricao', width: 40, align: 'left' },
        {
            label: 'Etapa', name: 'categoria', width: 16, align: 'left',
            func: categoria => humanizarCategoria(categoria),
        },
        {
            label: 'Ocorrências', name: 'quantidade', width: 12, align: 'right',
            func: q => <span style={{ color: q > 0 ? VERMELHO : VERDE, fontWeight: 600 }}>{numberFormat(q ?? 0)}</span>,
        },
        {
            label: 'Situação', name: 'ok', width: 32, align: 'right',
            func: (ok, id) => {
                const link = buscarCheck(id)?.link;

                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                        {!ok && link ? 
                            <ButtonWarning component={Link} to={link} name="Verificar Pendências" /> 
                        :
                            <Chip
                                label={'OK'}
                                size="small"
                                icon={<CheckCircleOutlinedIcon style={{ color: '#fff' }} />}
                                style={{ backgroundColor: VERDE, color: '#fff', fontWeight: 600 }}
                            />
                        }
                    </div>
                );
            },
        },
        { label: 'Id', name: 'id', key: true, hidden: true },
    ];

    return (
        <Grid item xs={12}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Checagens Operacionais</Typography>

                    { !loading &&
                        <Typography
                            variant="body2"
                            style={{ color: pendentes > 0 ? VERMELHO : VERDE, fontWeight: 600, marginBottom: 8 }}
                        >
                            {pendentes} de {dados.length} verificações com pendência
                        </Typography>
                    }

                    <div style={{ overflowX: 'auto' }}>
                        <div style={{ minWidth: 760 }}>
                            <Table
                                columns={columns}
                                tableData={dados}
                                actions={[]}
                                loading={loading}
                                page={null}
                                rowsPerPage={null}
                                sort={null}
                            />
                        </div>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default Checks;
